<wr-new-data-table
  [insideCard]="false"
  [localStorageIdentifier]="localStorageIdentifier()"
  [loadItemsFunction]="loadItems"
  [getCountFunction]="getCount"
  [showNewButton]="false"
  [form]="form"
  (lineClick)="open($event)">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="repairTaskText">Textfilter</label>
          <input type="text" nbInput id="repairTaskText" formControlName="text" placeholder="Titel oder Beschreibung…"
                 data-cy="repair-task-filter-text">
        </div>
        <div class="filter-control-group">
          <label class="label" for="repairTaskStatuses">Status</label>
          <nb-select id="repairTaskStatuses" formControlName="statuses" multiple placeholder="Alle"
                     data-cy="repair-task-filter-statuses">
            @for (status of statuses; track status) {
              <nb-option [value]="status">{{ status | repairTaskStatusTranslation }}</nb-option>
            }
          </nb-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="repairTaskContractor">Dienstleister</label>
          <nb-select id="repairTaskContractor" formControlName="contractorId" placeholder="Alle">
            <nb-option [value]="null">Alle</nb-option>
            @for (contractor of contractorOptions(); track contractor.id) {
              <nb-option [value]="contractor.id">{{ contractor.name }}</nb-option>
            }
          </nb-select>
        </div>
        @if (!buildingEquipmentId()) {
          <div class="filter-control-group">
            <label class="label" for="repairTaskSource">Herkunft</label>
            <nb-select id="repairTaskSource" formControlName="source" placeholder="Alle"
                       data-cy="repair-task-filter-source">
              <nb-option [value]="null">Alle</nb-option>
              @for (source of sources; track source) {
                <nb-option [value]="source">{{ sourceLabels[source] }}</nb-option>
              }
            </nb-select>
          </div>
          <div class="filter-control-group">
            <label class="label" for="repairTaskBuildingEquipment">TGA</label>
            <nb-select id="repairTaskBuildingEquipment" formControlName="buildingEquipmentId" placeholder="Alle">
              <nb-option [value]="null">Alle</nb-option>
              @for (equipment of buildingEquipmentOptions(); track equipment.id) {
                <nb-option [value]="equipment.id">{{ equipment.name }}</nb-option>
              }
            </nb-select>
          </div>
        }
      </div>
    </form>
  </ng-template>
  <ng-template dataColumn let-item key="status" display="Status" exportKey="status">
    <wr-repair-task-status-text [status]="item.status"></wr-repair-task-status-text>
  </ng-template>
  <ng-template dataColumn let-item key="title" display="Titel">
    {{ item.title }}
  </ng-template>
  <ng-template dataColumn let-item key="origin" [sortable]="false" [exportValue]="exportOrigin" display="Herkunft">
    {{ origin(item) }}
  </ng-template>
  <ng-template dataColumn let-item key="contractor" [sortable]="false" exportKey="contractor.name" display="Dienstleister">
    {{ item.contractor?.name ?? '–' }}
  </ng-template>
  <ng-template dataColumn let-item key="deadline" display="Frist">
    {{ item.deadline ? (item.deadline | date:'dd.MM.yyyy') : '–' }}
  </ng-template>
  <ng-template dataColumn let-item key="created" display="Erstellt">
    {{ item.created | date:'dd.MM.yyyy' }}
  </ng-template>
  <ng-template dataColumn let-item key="actions" [sortable]="false" display="Aktionen">
    @if (item.permissions.canEdit) {
      <div class="actions" data-cy="repair-task-actions" role="group" tabindex="-1"
           (click)="ignoreLineClick()" (keydown)="ignoreLineClick()">
        <nb-select size="small" [selected]="item.status" (selectedChange)="changeStatus(item, $event)"
                   data-cy="repair-task-status-change">
          @for (status of statuses; track status) {
            <nb-option [value]="status">{{ status | repairTaskStatusTranslation }}</nb-option>
          }
        </nb-select>
        @if (item.contractor) {
          <button nbButton size="small" status="info" outline (click)="resend(item)" data-cy="repair-task-resend"
                  [nbTooltip]="item.sentAt ? 'Erneut an Dienstleister senden' : 'An Dienstleister senden'">
            <nb-icon icon="paper-plane-outline" pack="eva"></nb-icon>
          </button>
        }
        <button nbButton size="small" status="danger" outline (click)="delete(item)" data-cy="repair-task-delete"
                nbTooltip="Löschen">
          <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
        </button>
      </div>
    }
  </ng-template>
</wr-new-data-table>
